(function () {
  var COLLECTION_STORAGE_PREFIX = 'tabakdiscount:collection-filters:v2:';
  var SHOP_STORAGE_KEY = 'tabakdiscount:shop-filter:v1';
  var FILTER_LOCATION_STORAGE_KEY = 'selectedPickupFilterLocationName';
  var FILTER_AVAILABILITY_STORAGE_KEY = 'selectedPickupFilterAvailabilityState';
  var SHOP_FILTER_PARAMETER = 'filter.p.m.custom.in_stock_locations';
  var PRODUCT_IMAGE_FILTER_PARAMETER = 'filter.p.m.custom.has_real_image';
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

  function isCollectionPage() {
    return (
      window.location.pathname.indexOf('/collections/') !== -1 &&
      document.querySelector('collection-section')
    );
  }

  function collectionStorageKey(pathname) {
    var normalizedPath = pathname.replace(/\/+$/, '') || '/';
    return COLLECTION_STORAGE_PREFIX + normalizedPath;
  }

  function isCollectionParameter(name) {
    return (
      (name.indexOf('filter.') === 0 &&
        name !== SHOP_FILTER_PARAMETER &&
        name !== 'filter.v.availability') ||
      name === 'sort_by'
    );
  }

  function filteredSearch(url, predicate) {
    var params = new URLSearchParams();

    url.searchParams.forEach(function (value, name) {
      if (predicate(name)) {
        params.append(name, value);
      }
    });

    return params.toString();
  }

  function write(key, search) {
    try {
      if (!search) {
        localStorage.removeItem(key);
        return;
      }

      localStorage.setItem(
        key,
        JSON.stringify({
          search: search,
          expiresAt: Date.now() + MAX_AGE_MS,
        })
      );
    } catch (error) {}
  }

  function read(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return '';

      var stored = JSON.parse(raw);
      if (
        !stored ||
        typeof stored.search !== 'string' ||
        typeof stored.expiresAt !== 'number' ||
        stored.expiresAt <= Date.now()
      ) {
        localStorage.removeItem(key);
        return '';
      }

      return stored.search;
    } catch (error) {
      return '';
    }
  }

  function collectionSearch(url) {
    return filteredSearch(url, isCollectionParameter);
  }

  function shopSearch(url) {
    return filteredSearch(url, function (name) {
      return name === SHOP_FILTER_PARAMETER;
    });
  }

  function save(url) {
    write(collectionStorageKey(url.pathname), collectionSearch(url));
    write(SHOP_STORAGE_KEY, shopSearch(url));
    saveFilterLocation(url);
    saveFilterAvailability(url);
  }

  function saveFilterLocation(url) {
    var values = url.searchParams.getAll(SHOP_FILTER_PARAMETER);
    var locationName = values
      .map(function (value) {
        return value.split('::')[0].trim();
      })
      .find(Boolean);

    try {
      if (locationName) {
        localStorage.setItem(FILTER_LOCATION_STORAGE_KEY, locationName);
      } else {
        localStorage.removeItem(FILTER_LOCATION_STORAGE_KEY);
      }
    } catch (error) {}
  }

  function saveFilterAvailability(url) {
    var state = url.searchParams.get('availability_choice');
    var availabilityValues = url.searchParams.getAll('filter.v.availability');

    if (!['in-stock', 'sold-out', 'all'].includes(state)) {
      if (availabilityValues.includes('1')) {
        state = 'in-stock';
      } else if (availabilityValues.includes('0')) {
        state = 'sold-out';
      } else if (url.searchParams.get('show_sold_out') === '1') {
        state = 'all';
      } else {
        state = '';
      }
    }

    try {
      if (state) {
        localStorage.setItem(FILTER_AVAILABILITY_STORAGE_KEY, state);
      } else {
        localStorage.removeItem(FILTER_AVAILABILITY_STORAGE_KEY);
      }
    } catch (error) {}
  }

  function appendSearch(url, search, predicate) {
    new URLSearchParams(search).forEach(function (value, name) {
      if (predicate(name)) {
        url.searchParams.append(name, value);
      }
    });
  }

  function saveCurrentUrl() {
    save(new URL(window.location.href));
  }

  function decorateCollectionLink(event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    if (!(event.target instanceof Element)) return;

    var anchor = event.target.closest('a[href]');
    if (!anchor || anchor.target || anchor.hasAttribute('download')) return;

    // Filter URLs are authoritative. Reapplying stored values here would undo
    // removing one filter or clearing a zero-result filter combination.
    if (
      anchor.hasAttribute('data-filter-link') ||
      anchor.closest('[data-filter-reset]')
    ) {
      return;
    }

    var destination;
    try {
      destination = new URL(anchor.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (
      destination.origin !== window.location.origin ||
      destination.pathname.indexOf('/collections/') !== 0
    ) {
      return;
    }

    if (!collectionSearch(destination)) {
      appendSearch(
        destination,
        read(collectionStorageKey(destination.pathname)),
        isCollectionParameter
      );
    }
    if (!shopSearch(destination)) {
      appendSearch(destination, read(SHOP_STORAGE_KEY), function (name) {
        return name === SHOP_FILTER_PARAMETER;
      });
    }

    if (!hasAvailabilityChoice(destination.searchParams)) {
      destination.searchParams.set('availability_choice', 'in-stock');
      if (!destination.searchParams.has(SHOP_FILTER_PARAMETER)) {
        destination.searchParams.append('filter.v.availability', '1');
      }
    }
    if (!destination.searchParams.has(PRODUCT_IMAGE_FILTER_PARAMETER)) {
      destination.searchParams.set(PRODUCT_IMAGE_FILTER_PARAMETER, '1');
    }

    anchor.href = destination.toString();
  }

  function hasAvailabilityChoice(params) {
    return (
      params.has('availability_choice') ||
      params.has('filter.v.availability') ||
      params.get('show_sold_out') === '1'
    );
  }

  document.addEventListener('click', decorateCollectionLink, true);

  if (!isCollectionPage()) return;

  saveCurrentUrl();

  document.addEventListener(
    'collection:filter-change',
    function (event) {
      if (!event.detail || !event.detail.url) return;

      try {
        save(new URL(event.detail.url, window.location.origin));
      } catch (error) {}
    },
    true
  );

  window.addEventListener('popstate', function () {
    save(new URL(window.location.href));
  });
})();
